import React, { FC } from 'react';
import { partition } from 'services/partitions';

interface OwnProps {
  value: string;
  start: number;
  end?: number;
}

const WrapStrong: FC<OwnProps> = ({ value, start, end }) => {
  const { before, target, after } = partition(value, start, end);
  return (
    <>
      {before}
      <strong> {target} </strong>
      {after}
    </>
  );
};

export default WrapStrong;
